import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { useBoundStore } from 'useStore';
import fetchExchangeRateData from '../services/fetchExchangeRateData';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';

export default function useExchangeRateData() {
	const { accessToken } = useAuth();
	const year = useBoundStore((state) => state.forecastEditedExchangeRateYear);
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;

	const exchangeRateQuery = useQuery({
		queryKey: ['exchangeRate', { year, countryId }],
		queryFn: () => fetchExchangeRateData({ accessToken, year, countryId }),
		enabled: !!year && !!countryId,
		staleTime: Infinity,
	});

	return exchangeRateQuery;
}
